@import 'src/styles/variabels';

.root {
  color: $color-red;
}
